export default __webpack_public_path__ + "static/media/call_&_sms.c8c3c06d.svg";